import { Box, Grid, Typography, styled } from '@mui/material'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import AdminDetailInfo from '../../../../backoffice/library/ui/components/AdminDetailInfo'
import DetailInfoPanel from '../../../../shared/components/DetailInfoPanel'
import FavoriteButton from '../../../../shared/components/buttons/FavoriteButton'
import ShareIcon from '../../../../shared/components/icons/ShareIcon'
import VerifyAccessRoute from '../../../../shared/components/routes/VerifyAccessRoute'
import { MoreInfoDetail } from '../../../library/models/resource'
import { useNewsContent } from '../hooks/useNewsContent'

interface NewsContentProps {
  newsSelected: any
  isAdmin: boolean
  isMobile: boolean
  authUser: any
  favoriteState: boolean
  setFavoriteState: (state: boolean) => void
  infoDetail: MoreInfoDetail
}

const CustomContainer = styled('div')({
  fontFamily: 'Poppins',
  '& img': {
    maxWidth: '100%'
  }
})

const NewsContent = ({ newsSelected, isAdmin, isMobile, authUser, favoriteState, setFavoriteState, infoDetail }: NewsContentProps) => {
  const { t } = useTranslation(['global'])
  const { handleFavoriteClick } = useNewsContent()

  const handleFavorite = (news_id: number) => (state: boolean) => {
    const result = handleFavoriteClick(news_id)(state)
    setFavoriteState(result)
  }

  return (
    <Grid item xs={12} md={isAdmin ? 8 : 9}>
      {isAdmin ? (
        <AdminDetailInfo resourceSelected={newsSelected} />
      ) : (
        <>
          <Box sx={{ pb: 4 }}>
            <Typography variant={isMobile ? 'h5' : 'h3'} sx={{ fontWeight: 400 }}>
              {newsSelected.title}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pt: 2 }}>
              <Box>
                <Typography color="text.secondary">{`${dayjs(newsSelected.created_at).fromNow()}`}</Typography>
                <Typography color="text.secondary" variant="body2">{`${t('writter-by')} : ${newsSelected.creator.name}`}</Typography>
              </Box>
              <Box sx={{ display: 'flex' }}>
                {authUser !== null && <FavoriteButton handleClick={handleFavorite(newsSelected.id)} favoriteState={favoriteState} />}
                <ShareIcon
                  meta={true}
                  visibility={newsSelected.visibility}
                  title={newsSelected.title}
                  description={newsSelected.title}
                  link={window.location.href}
                  multimedia={`${import.meta.env.VITE_AWS_URL}/novelties/${newsSelected.image_url}`}
                  buttonText={t('share')}
                  type="news"
                />
              </Box>
            </Box>
          </Box>
        </>
      )}

      <VerifyAccessRoute visibility={newsSelected.visibility} />

      <img src={`${import.meta.env.VITE_AWS_URL}/novelties/${newsSelected.image_url}`} alt={newsSelected.title} style={{ width: '100%' }} />
      <Box>
        <CustomContainer dangerouslySetInnerHTML={{ __html: newsSelected.content }} />
      </Box>
      {isMobile && <DetailInfoPanel attributes={infoDetail} />}
    </Grid>
  )
}

export default NewsContent
